<template>
  <el-card
    class="box-card activity"
    shadow="hover"
    :body-style="{ padding: '0 20px 0 20px' }"
    v-loading="loading"
  >
    <div slot="header" class="clearfix stats" :class="extraClass">
      <div class="box title">{{ card_title }}</div>
      <el-button type="text" class="box" @click="$emit('push-add')"
        ><i class="mdi mdi-plus-circle-outline" style="font-size: 24px"></i
      ></el-button>
    </div>

    <ActivityFlowCardItem
      v-for="(o, index) in data"
      :key="index"
      :title="o[mapData.title]"
      :qty="o[mapData.qty]"
    >
      <template v-slot:item_title="props">
        <slot name="item_title" v-bind="props">
          {{ props.title }}
        </slot>
      </template>
      <template v-slot:item_qty="props">
        <slot name="item_qty" v-bind="props">
          <el-link type="primay" @click="$emit('click-item-qty', props)">
            <span v-if="`${props.qty}`.includes('.')">{{
              props.qty | formatterMoney
            }}</span>
            <span v-else-if="props.qty >= 0">{{ props.qty }}</span>
          </el-link>
        </slot>
      </template>
    </ActivityFlowCardItem>
  </el-card>
</template>

<script>
import ActivityFlowCardItem from "./ActivityFlowCardItem.vue";

export default {
  name: "ActivityFlowCard",
  props: {
    card_title: {
      type: String,
      required: true
    },
    data: {
      type: Array
    },
    mapData: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    extraClass: {
      type: String,
      default: "",
      required: false
    }
  },
  components: {
    ActivityFlowCardItem
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.box-card.activity {
  width: 100%;

  .el-card__header {
    // background: #2484c4;
    padding: 0;

    .clearfix {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;
      font-weight: 900;
      font-size: 14px;
      text-transform: uppercase;
      color: #ffffff;
      margin: 0;
      padding: 0;

      &.stats {
        background: $text-color-accent;
      }

      button {
        float: right;
        align-self: flex-end;
        padding: 3px 0;
        color: #ffffff;

        span {
          padding-bottom: 6px;
        }
      }
    }
  }
}
</style>
